import './plugins/wpx-form';
import './plugins/base';
import './plugins/vee-validate';
import './plugins/vue-world-map';
import { socket } from './socket.io';
import 'toastr/toastr.scss';
import Vue from 'vue';
import VueAxios from 'vue-axios';
import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import Chartist from 'vue-chartist';
import { ErrorDialogPlugin, InfoDialogPlugin, SuccessDialogPlugin } from '@/plugins/GlobalDialog';
import { NotificationsPlugin } from '@/plugins/notifications';
import store from '@/Store';
import router from '@/router';
import ConvertTimestamp from '@/plugins/convert-timestamp';
import Linkify from '@/plugins/linkify';
import GetHourDifference from '@/plugins/dates-hour-difference';
import TicketClientLogged from '@/plugins/ticket-client-logged';
import FormatKiB from "@/plugins/format-kib";

Vue.config.productionTip = false;
Vue.use(VueAxios, Axios);
Vue.use(Chartist);

Vue.use(SuccessDialogPlugin);
Vue.use(ErrorDialogPlugin);
Vue.use(InfoDialogPlugin);

Vue.use(ConvertTimestamp);
Vue.use(Linkify);
Vue.use(TicketClientLogged);
Vue.use(GetHourDifference);
Vue.use(FormatKiB)

Vue.use(NotificationsPlugin({
  showDuration: 300,
  hideDuration: 1000,
  timeOut: 10000,
  extendedTimeOut: 1000,
}));

Vue.axios.defaults.baseURL = `${window.location.origin}/api`;
Vue.axios.defaults.responseType = 'json';

Vue.axios.interceptors.request.use((config: AxiosRequestConfig) => {
  if (store.getters.jwt) {
    config.headers.common.Authorization = store.getters.jwt;
  }

  return config;
});

Vue.axios.interceptors.response.use(undefined, (error) => {
  const response: AxiosResponse = error.response;
  if (response.status === 401 &&
    (response.data.message === 'No credentials found for given \'iss\'' || response.data.exp === 'token expired')
  ) {
    store.commit('USER_LOGOUT');
    socket.disconnect();
    router.push({
      name: 'auth_login',
    });
    Vue.prototype.$notifications.error('Invalid token provided. Please login again.', 'Authentication Error', {
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000,
    });
  } else {
    throw error;
  }
});
